import type { Ref } from 'vue';
import type { NestedKeyOf } from '@/shared/types';

export type Locale = 'ja' | 'en';

type UseLocaleReturn<T extends Record<string, unknown>> = {
    t: (key: NestedKeyOf<T>, params?: Record<string, string | number>) => string;
    locale: Ref<Locale>;
    switchLocale: (newLocale: Locale) => void;
};

type I18nGlobal = {
    t: (key: string, params?: Record<string, string | number>) => string;
    locale: { value: string };
};

type I18nInstance = {
    global: I18nGlobal;
};

/**
 * 国際化のためのComposable
 * @param i18n - vue-i18nのインスタンス（モジュールレベルで作成したもの）
 * @param locale - ロケールのref（モジュールレベルで作成したもの）
 * @returns t関数、locale、switchLocale関数
 */
export const useLocale = <T extends Record<string, unknown>>(
    i18n: I18nInstance,
    locale: Ref<Locale>
): UseLocaleReturn<T> => {
    const t = (key: NestedKeyOf<T>, params?: Record<string, string | number>): string => {
        return String(i18n.global.t(key as string, params));
    };

    const switchLocale = (newLocale: Locale) => {
        locale.value = newLocale;
        i18n.global.locale.value = newLocale;
    };

    return {
        t,
        locale,
        switchLocale,
    };
};
